import { Label } from "@/components/ui/Statistic/Label";
import { Root } from "@/components/ui/Statistic/Root";
import { Value } from "@/components/ui/Statistic/Value";

export const Statistic = Object.assign(Root, {
    Label,
    Value,
});
